import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import logoImg from "../Images/logo.png";
import { MdLocationOn, MdEmail } from "react-icons/md";

const Header = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fluid border-bottom py-2">
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center px-3">
        
        {/* Left side: Logo */}
        <div className="d-flex align-items-center mb-2 mb-md-0">
          <img
            src={logoImg}
            alt="dellson logo"
            style={{ height: "70px", cursor: "pointer" }}
            onClick={() => navigate("/")}
          />
        </div>
{/* Right side: Address & Email */}
<div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center">

  {/* Address */}
 <div className="d-flex align-items-center gap-1">

    <div
      className="bg-primary rounded d-flex align-items-center justify-content-center"
      style={{ width: "36px", height: "36px" }}
    >
      <MdLocationOn color="white" size={20} />
    </div>
    <div>
      <div className="fw-bold">Bindki</div>
      <small className="text-muted">OFFICE ADDRESS</small>
    </div>
  </div>

  {/* Email (GAP HERE) */}
  <div className="d-flex align-items-center gap-2 ms-sm-4 ms-md-5">
    <div
      className="bg-primary rounded d-flex align-items-center justify-content-center"
      style={{ width: "36px", height: "36px" }}
    >
      <MdEmail color="white" size={20} />
    </div>
    <div>
      <div className="fw-bold">dellsonpumpsandpipes@gmail.com</div>
      <small className="text-muted">EMAIL ADDRESS</small>
    </div>
  </div>

</div>

      </div>
    </div>
  );
};

export default Header;
